import { render, staticRenderFns } from "./ChildRecord.vue?vue&type=template&id=bf07a406&scoped=true&"
import script from "./ChildRecord.vue?vue&type=script&lang=js&"
export * from "./ChildRecord.vue?vue&type=script&lang=js&"
import style0 from "./ChildRecord.vue?vue&type=style&index=0&id=bf07a406&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf07a406",
  null
  
)

export default component.exports